import { ICON_COLOR } from '@zep-us/zus/tokens';
import { SparkleFrameIcon } from '@/icons';
import { type ButtonProps, DrawerTrigger, IconButton } from '@/ui_v3';
export const MobileTrigger = (props: ButtonProps & {
  onClick: () => void;
}) => {
  return <DrawerTrigger asChild onClick={props.onClick} data-sentry-element="DrawerTrigger" data-sentry-component="MobileTrigger" data-sentry-source-file="MobileTrigger.tsx">
      <IconButton size="xs" className="flex mobile-lg:hidden" variant="outlined" intent="neutral" disabled={props.disabled} data-sentry-element="IconButton" data-sentry-source-file="MobileTrigger.tsx">
        <SparkleFrameIcon size="xs" fill={props.disabled ? ICON_COLOR.neutral : ICON_COLOR.default} opacity={props.disabled ? 0.54 : 1} data-sentry-element="SparkleFrameIcon" data-sentry-source-file="MobileTrigger.tsx" />
      </IconButton>
    </DrawerTrigger>;
};